import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引入 Element UI
import ElementUI from 'element-ui';
// 引入样式文件
import 'element-ui/lib/theme-chalk/index.css';
import VueQuillEditor from 'vue-quill-editor'
// 引入quill样式
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.prototype.$bus = new Vue()
Vue.use(VueQuillEditor)

Vue.config.productionTip = false
Vue.prototype.$baseUrl = 'https://two.hrxsl.com'
Vue.prototype.$img = function(img) {
    return "https://hr-xinshili.oss-cn-beijing.aliyuncs.com" + img
}
Vue.prototype.$Localimg = function(img) {
    return "https://two.hrxsl.com/pcImages/" + img
}
Vue.prototype.$imageUrl = "https://hr-xinshili.oss-cn-beijing.aliyuncs.com"
Vue.use(ElementUI);
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')